import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Service } from '../../../../models/service.model';
import { WidgetServicesDisplayComponent } from '../../../../shared/components/widget-displays/widget-services-display/widget-services-display.component';
import { SharedModule } from '../../../../shared/shared.module';
import {
  getActiveServices,
  getServicesLoaded,
  getServicesLoading,
  getTotalActiveServiceLocations,
  LoadServices,
  State,
} from '../../../../store';

@Component({
  selector: 'app-ons-widget-services',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetServicesDisplayComponent, SharedModule],
  template: `
    <app-widget-services-display
      [hyperlink]="'/services'"
      [queryParams]="{ groupBy: 'Location' }"
      [loading]="isLoading()"
      [navigateOnClick]="navigateOnClick()"
      [serviceCount]="totalOpenServices()?.length"
      [locationCount]="totalActiveLocation()"
    ></app-widget-services-display>
  `,
})
export class WidgetServicesComponent implements OnInit, OnDestroy {
  readonly navigateOnClick = input<boolean>(false);

  private readonly store = inject(Store<State>);

  private readonly destroy$ = new Subject<void>();

  readonly totalActiveLocation = toSignal<number>(
    this.store.select(getTotalActiveServiceLocations),
  );

  readonly totalOpenServices = toSignal<Service[]>(
    this.store.select(getActiveServices),
  );

  readonly isLoading = toSignal<boolean>(this.store.select(getServicesLoading));

  ngOnInit(): void {
    this.store
      .select(getServicesLoaded)
      .pipe(takeUntil(this.destroy$))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new LoadServices());
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
